import { effect, Injectable, signal } from '@angular/core';
export type Theme = 'light' | 'dark';
@Injectable({ providedIn: 'root' })
export class ThemeStore {
  private readonly STORAGE_KEY = 'theme';
  private theme = signal<Theme>('light');
  theme$ = this.theme.asReadonly();
  constructor() {
    effect(() => {
      const theme = this.theme$();
      document.documentElement.setAttribute('data-theme', theme);
      localStorage.setItem(this.STORAGE_KEY, theme);
    });
  }

  initTheme() {
    const saved = localStorage.getItem(this.STORAGE_KEY) as Theme | null;
    this.theme.set(saved ?? 'light');
  }
  toggle() {
    this.theme.update((t) => (t === 'light' ? 'dark' : 'light'));
  }

  setTheme(th: Theme) {
    if (th !== this.theme()) {
      this.theme.set(th);
    }
  }
  isDark() {
    return this.theme() === 'dark';
  }
}
